import _extends from '@babel/runtime/helpers/extends';
import _jsx from '@babel/runtime/helpers/jsx';
import React from 'react';
import 'prop-types';
import cn from 'classnames';
import { StyledLabel } from '@vpp-frontend-components/styled-label';
import { stringIncludes, PriceFontSize } from '@vpp-frontend-components/common';
import { componentEnhance } from '@vpp-frontend-components/component-enhance';
import { Image } from '@vpp-frontend-components/image';
const namespace = 'ui-pdp-payment-icon';
const PaymentIcon = _ref => {
  let {
    className = '',
    icons
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: cn(namespace, className)
  }, void 0, icons.map(icon => {
    var _icon$name;
    return /*#__PURE__*/_jsx("div", {
      className: `${namespace}__container`
    }, icon.id, /*#__PURE__*/_jsx("div", {
      className: cn(`${namespace}__size`, {
        'promo-ahora': stringIncludes(icon === null || icon === void 0 || (_icon$name = icon.name) === null || _icon$name === void 0 ? void 0 : _icon$name.toLowerCase(), 'ahora'),
        'size-text': icon === null || icon === void 0 ? void 0 : icon.text_right
      })
    }, void 0, icon.url ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/_jsx(Image, {
      id: icon.id,
      alt: icon === null || icon === void 0 ? void 0 : icon.name,
      className: cn(namespace, className),
      width: icon === null || icon === void 0 ? void 0 : icon.width,
      height: icon === null || icon === void 0 ? void 0 : icon.height,
      src: icon.url.src
    }), !icon.label && icon.disclaimer_ids && /*#__PURE__*/_jsx("sub", {
      className: cn(`${namespace}__disclaimer`)
    }, void 0, icon.disclaimer_ids), icon.text_right && /*#__PURE__*/_jsx(StyledLabel, {
      haga: true,
      className: cn(`${namespace}__size-text`),
      color: icon.text_right.color,
      font_family: icon.text_right.font_family,
      font_size: icon.text_right.font_size,
      as: "p",
      text: componentEnhance.jsx(icon.text_right.text, icon.text_right.values, null, PriceFontSize.PAYMENT_ICON[icon.text_right.font_size])
    })) : /*#__PURE__*/_jsx(StyledLabel, {
      "aria-hidden": true,
      as: "span",
      className: cn(`${namespace}__name-icon`),
      text: icon.name
    })), icon.icon_label && /*#__PURE__*/React.createElement(StyledLabel, _extends({
      as: "span",
      className: cn(`${namespace}__label-bank`, `_${icon.id}`)
    }, icon.icon_label)), icon.label && /*#__PURE__*/_jsx("div", {
      className: cn(`${namespace}__label`, `_${icon.id}`)
    }, void 0, /*#__PURE__*/_jsx("span", {
      className: "andes-visually-hidden"
    }, void 0, icon.name), /*#__PURE__*/React.createElement(StyledLabel, _extends({
      as: "span"
    }, icon.label)), icon.disclaimer_ids && /*#__PURE__*/_jsx("sub", {
      className: cn(`${namespace}__disclaimer`)
    }, void 0, icon.disclaimer_ids)));
  }));
};
PaymentIcon.displayName = 'PaymentIcon';
const PaymentIconWithMemo = /*#__PURE__*/React.memo(PaymentIcon);
export { PaymentIconWithMemo as PaymentIcon };
